export enum Role {
  Admin = "Administration",
  Dev = "Developer",
  Employee = "Employee",
  Business = "Business",
  Marketing = "Marketing Team",
  Backoffice = "Backoffice Administration",
  Financial = "Financial Bank account team",
}

export interface IRole {
  id?: number;
  name: string;
  order: number;
  users: string;
}

export interface IRoleForm {
  name: string;
  order: number;
}
